import { Signup } from '@platzi/micro-ui.signup';
import React, { useEffect, useState } from 'react'

const useSignUpModal = () => {
  const [showSignup, setShowSignup] = useState(false);
  const [signupUrl, setSignupUrl] = useState('');

  useEffect(() => {
    setSignupUrl(window.location.href);
  }, []);

  const openSignup = () => {
    setShowSignup(true);
  }

  const closeSignup = () => {
    setShowSignup(false);
  }

  const SignUpComponent = () => <Signup showSignup={showSignup} closeSignup={closeSignup} isModal customNextUrl={signupUrl} />

  return { showSignup, setShowSignup, signupUrl, setSignupUrl, openSignup, closeSignup, SignUpComponent };
}

export default useSignUpModal